import { t } from '@lingui/macro';

import { Page, PageHeader, FilterContainer, PanelContainer } from '../../page-framework';
import { BusinessServiceFilter, SiteFilter, StatusFilter, TestTypeFilter, TimeRangeFilter } from '../../filters';
import { TestListPanel } from '../../panels';

export const pageId = 'tests';

export default function TestsPage() {
    return (
        <Page id={pageId}>
            <PageHeader title={t`Service Tests`}>
                <FilterContainer>
                    <TimeRangeFilter required />
                    <BusinessServiceFilter />
                    <SiteFilter />
                    <StatusFilter />
                    <TestTypeFilter />
                </FilterContainer>
            </PageHeader>
            <PanelContainer>
                <TestListPanel hideTitle flexHeight />
            </PanelContainer>
        </Page>
    );
}
